// src/components/Login/LoginCard.tsx
import React, { useState } from "react";
import { reduxForm, Field, InjectedFormProps } from "redux-form";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import { ACTION_DISPLAY_TYPES, FIELD_TYPES } from "../../constants/enums";
import { PAGES } from "../../constants/localization";
import BrightwellBadge from "../../assets/images/icons/rebrand/brightwell-symbol-badge.svg";

// types
import {
  LoginCardOwnProps,
  LoginFormValues,
} from "../../types/components/Login";

// ui components
import Card from "../Common/Card";
import Action from "../Common/Action";
import ErrorBlock from "../Common/ErrorBlock";
import DynamicInputField from "../Common/DynamicFields/DynamicInputField";
import i18n from "../../i18n/config";

type LoginCardProps = LoginCardOwnProps &
  InjectedFormProps<LoginFormValues, LoginCardOwnProps>;

const LoginCard = ({
  handleSubmit,
  submitting,
  onSubmit,
  errors
}: LoginCardProps) => {

  return (
    <Card
      icon={<img src={BrightwellBadge} alt="Brightwell Badge" />}
      title={i18n.t("PAGES.AUTH.LOGIN.CARD.TITLE")}
      titleWeight="strong"
      wrapBody={false}
    >
      <form
        name="login"
        data-testid="login-form"
        onSubmit={handleSubmit(onSubmit)}
        className="v2"
      >
        <Card.Body>
          {errors && <ErrorBlock filterErrors={false} errors={errors} />}

          <div className="form-group mb-8">
            <label htmlFor="username" className="auth-label bold">
              {PAGES.AUTH.USERNAME}
            </label>
            <Field
              id="username"
              component="input"
              name="username"
              type="text"
              autoFocus
              required
              disabled={submitting}
              className="form-control"
            />
          </div>

          <div className="flex-row align-items-center">
            <DynamicInputField
              id="rememberMe"
              name="rememberMe"
              type={FIELD_TYPES.BOOL}
              label={PAGES.AUTH.REMEMBER_ME}
              hideOptional
              className="remember-me-checkbox col"
            />
            <div className="text-right row-link col">
              <Link to={ROUTES.SETTINGS.FORGOT_USERNAME} className="bold" data-cy="forgot-username-link" data-testid="forgot-username-link">
                {i18n.t("PAGES.AUTH.LOGIN.CARD.FORGOT_USERNAME")}
              </Link>
            </div>
          </div>
        </Card.Body>

        <Card.Footer stretch>
          <Action
            title={PAGES.AUTH.LOGIN}
            loading={submitting}
            displayType={ACTION_DISPLAY_TYPES.PRIMARY}
            className="btn-md"
            type="submit"
          />
        </Card.Footer>
      </form>
    </Card>
  );
};

export default reduxForm<LoginFormValues, LoginCardOwnProps>({
  form: "Login",
  enableReinitialize: true,
})(LoginCard);